import React from 'react';

interface DashboardLoadingGateProps {
    initialDashboardReady: boolean;
    /** When true, render dashboard under the frosted init overlay so blur shows page content. */
    showContentUnderOverlay?: boolean;
    children: React.ReactNode;
}

export const DashboardLoadingGate: React.FC<DashboardLoadingGateProps> = ({
    initialDashboardReady,
    showContentUnderOverlay = false,
    children,
}) => {
    if (!initialDashboardReady && !showContentUnderOverlay) {
        return null;
    }
    return <>{children}</>;
};
